/** Full stacked lockup (mark + “doimpo collab”). Override via NEXT_PUBLIC_LOGO_SRC. */
export const BRAND_LOGO_SRC =
  process.env.NEXT_PUBLIC_LOGO_SRC ?? "/logos/logo.svg";

export const BRAND_LOGO_WIDTH = 102;
export const BRAND_LOGO_HEIGHT = 84;

/** “do!” mark only — use in compact UI (header, avatars). */
export const BRAND_MARK_SRC = "/logos/mark.svg";
export const BRAND_MARK_WIDTH = 102;
export const BRAND_MARK_HEIGHT = 65;
